import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { DropdownOptionModel } from '@Common/Forms/models/dropdown-option.model';

export class AnalysisField implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    options: DropdownOptionModel[];

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        label: string,
        property: string,
        options?: DropdownOptionModel[]
    ) {
        this.fieldComponent = fieldComponent;
        this.label = label;
        this.property = property;
        if (options) {
            this.options = options;
        }
    }
}
